import css from 'styled-jsx/css';

const styles = css.global`#emp-garantia-contrato-passo-a-passo {
  overflow: hidden;
  padding-top: 32px;
}

#emp-garantia-contrato-passo-a-passo .emp-garantia-contrato-passo-a-passo-desktop,
#emp-garantia-contrato-passo-a-passo .boleto-logo-santander {
  display: none;
}

#emp-garantia-contrato-passo-a-passo .emp-garantia-contrato-passo-a-passo-title {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  margin: 0;
}

#emp-garantia-contrato-passo-a-passo .emp-garantia-contrato-passo-a-passo-title b {
  font-weight: 900;
}

#emp-garantia-contrato-passo-a-passo .emp-garantia-contrato-passo-a-passo-mobile {
  margin-top: 24px;
}

#emp-garantia-contrato-passo-a-passo .custom-carousel .embla__container {
  width: 204px;
}

#emp-garantia-contrato-passo-a-passo .emp-garantia-contrato-passo-a-passo-card {
  width: 204px;
  height: 182px;
  border-radius: 3px;
  border: 1px solid #ccc;
  background: #FBFBFB;
  margin-right: 24px;
  padding: 24px 27px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  position: relative;
}

#emp-garantia-contrato-passo-a-passo .separador-slide {
  width: 24px;
  height: 1px;
  background: red;
  position: absolute;
  right: -25px;
  top: 50%;
}

#emp-garantia-contrato-passo-a-passo .emp-garantia-contrato-passo-a-passo-card-img {
  width: 40px;
  height: 40px;
}

#emp-garantia-contrato-passo-a-passo .emp-garantia-contrato-passo-a-passo-card-text {
  color: #222;
  text-align: center;
  font-family: "SantanderText";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

#emp-garantia-contrato-passo-a-passo .emp-garantia-contrato-passo-a-passo-card-text b {
  color: #C00;
  font-family: "SantanderText";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

#emp-garantia-contrato-passo-a-passo .emp-garantia-contrato-passo-a-passo-card-text a {
  color: #222;
  font-family: "SantanderText";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  text-decoration-line: underline;
  white-space: nowrap;
}

#emp-garantia-contrato-passo-a-passo .home-pagination {
  margin-top: 20px;
  max-width: 100%;
  justify-content: center;
  margin-bottom: 20px;
}

#passo-a-passo-gerar-boleto {
  max-width: 272px;
  margin: auto;
  height: 48px;
}

/* #boleto-whats-app-desk {
  display: none;
} */

#boleto-whats-app-desk {
  /* height: 364px; */
  display: flex;
  background: #DEEDF2;
  padding: 48px 0;
  margin-top: 48px;
}

#boleto-whats-app-desk .ctn-home-24 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#boleto-whats-app-desk .whats-app-textos {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* height: 180px; */
}

#boleto-whats-app-desk .whats-app-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  margin: 0;
}

#boleto-whats-app-desk .whats-app-titulo b {
  font-family: "SantanderHeadline";
  font-weight: 900;
}

#boleto-whats-app-desk .whats-app-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-top: 30px;
}

#boleto-whats-app-desk .whats-app-texto b {
  font-weight: 600;
}

#boleto-whats-app-desk .whats-app-texto .is-desk {
  display: none;
}

#boleto-whats-app-desk .whats-app-texto a {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
}

#boleto-whats-app-desk .whats-app-qrcode {
  display: none;
}

@media (min-width: 992px) {
  #emp-garantia-contrato-passo-a-passo {
    position: relative;
    overflow: visible;
    padding-top: 56px;
  }

  #emp-garantia-contrato-passo-a-passo .boleto-logo-santander {
    position: absolute;
    top: -172px;
    right: 0;
    display: block;
    opacity: 0.1;
    z-index: -1;
  }

  #emp-garantia-contrato-passo-a-passo .emp-garantia-contrato-passo-a-passo-mobile {
    display: none;
  }

  #emp-garantia-contrato-passo-a-passo .emp-garantia-contrato-passo-a-passo-title {
    font-size: 32px;
    line-height: normal;
    text-align: center;
  }

  #emp-garantia-contrato-passo-a-passo .emp-garantia-contrato-passo-a-passo-desktop {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    margin-top: 40px;
  }

  #emp-garantia-contrato-passo-a-passo .emp-garantia-contrato-passo-a-passo-card {
    width: 100%;
    height: auto;
    margin-right: 0;

  }

  #passo-a-passo-gerar-boleto {
    margin: 40px auto 0;
  }

  #boleto-whats-app-desk {
    height: 364px;
    display: flex;
    background: #DEEDF2;
    padding: 48px 0;
    margin-top: 48px;
  }

  #boleto-whats-app-desk .ctn-home-24 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  #boleto-whats-app-desk .whats-app-textos {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 180px;
  }

  #boleto-whats-app-desk .whats-app-titulo {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    margin: 0;
  }

  #boleto-whats-app-desk .whats-app-titulo b {
    font-family: "SantanderHeadline";
    font-weight: 900;
  }

  #boleto-whats-app-desk .whats-app-texto {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-top: 0;
  }

  #boleto-whats-app-desk .whats-app-texto .is-desk {
    display: inline;
  }

  #boleto-whats-app-desk .whats-app-texto a {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
  }

  #boleto-whats-app-desk .whats-app-qrcode {
    display: block;
    width: 202px;
  }
}

@media(min-width: 992px) and (max-width: 992px){
  #emp-garantia-contrato-passo-a-passo .boleto-logo-santander {
    top: -155px;
  }
}`;

export default styles;